import {
  Box,
  Button,
  Card, CardContent, CardHeader, Divider,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from '../../../../icons/external-link';
import STRING_KEYS from '../../../../language/keys';
import { Anchor } from '../../../../components/Anchor';
import ContactDetails from '../../../../components/ContactDetails';
import ContactDetailsModal, { ContactDetail } from '../../../../components/ContactDetailsModal';
import { cardStyle } from './style';

type TalentContactInfoProps = {
  talentId: string,
  emails: EmailItem[],
  phones: PhoneItem[],
  isShowUpdateContactInfo: boolean,
  handleEmailPhoneChanged?: (data:ContactDetail) => void,
  isOpenModal?: boolean,
  onUpdateClick?: (value:boolean) => void
}

const TalentContactInfo = ({
  talentId,
  emails,
  phones,
  handleEmailPhoneChanged,
  isOpenModal,
  onUpdateClick,
  isShowUpdateContactInfo,
}:TalentContactInfoProps):JSX.Element => {
  const { t: translate } = useTranslation();

  const updateClick = (val:boolean) => {
    if (onUpdateClick) {
      onUpdateClick(val);
    }
  };

  const handleChange = (data:ContactDetail) => {
    if (handleEmailPhoneChanged) {
      handleEmailPhoneChanged(data);
    }
  };

  return (
    <>
      <Card id="contact-info"
        style={ cardStyle.card }
      >
        <Anchor id="contact-details" />
        <Box style={ cardStyle.box } >
          <CardHeader title={ translate(STRING_KEYS.CONTACT_INFORMATION) } />
          {isShowUpdateContactInfo && (
            <Button
              startIcon={ <ExternalLink /> }
              style={ cardStyle.talentsButton }
              onClick={ () => updateClick(true) }
            >{translate(STRING_KEYS.UPDATE_CONTACT_INFO)}
            </Button>
          )}
        </Box>
        <Divider />
        <CardContent style={ cardStyle.content }>
          <ContactDetails
            arrEmails={ emails }
            arrPhones={ phones }
            disabled
          />
        </CardContent>
      </Card>
      {isOpenModal && (
        <ContactDetailsModal
          currentTalentId={ talentId }
          isOpen={ isOpenModal }
          onClose={ () => updateClick(false) }
          onUpdate={ (data) => {
            handleChange(data);
          } }
        />
      )}
    </>
  );
};

TalentContactInfo.defaultProps = {
  handleEmailPhoneChanged: null,
  isOpenModal: false,
  onUpdateClick: null,
};

export default React.memo(TalentContactInfo);
